export default function initBadgeCarousel () {
  $('.badge-swiper').slick({
    vertical: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    verticalSwiping: true,
    adaptiveHeight: true,
    arrows: true,
    mobileFirst: true,
    touchMove: false,
    prevArrow: $('.badge-swiper--prev'),
    nextArrow: $('.badge-swiper--next')
  });
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/poi/badgeCarousel.js